
import {Component} from 'vue-property-decorator'
import {BaseApp} from '~/core/Base'

@Component
export default class App extends BaseApp {}
